import { faComment } from "@fortawesome/free-solid-svg-icons";
import { isDefinedString } from "et3-type-guards";
import { getSelectedEventData } from "../../../../helpers/et3-get-selected-event-data";
import getTBWStore from "../../../../stores/developer-store/tbw-store";
import getSuperviseStore from "../../../../stores/supervisor-store/supervise-store";
import Et3Button from "../../../et3-button";
import { withLiteObserverAndTheme } from "../../../et3-enhanced-render";
import Et3TextInput from "../../../et3-input/et3-text-input";
import React from "react";
import ET3Div from "../../../et3-div";

const SuperviseProofPopUp = withLiteObserverAndTheme((props) => {
  const { theme } = props;
  const { colors } = theme;
  const status = getTBWStore().TBWAuditIssue.get();
  const { eventIDNumber } = getSelectedEventData();
  const isEnabled = isDefinedString(getTBWStore().superviseEventProof.get());

  return (
    <React.Fragment>
      <Et3TextInput
        size="MEDIUM"
        withShadow={true}
        type={"textarea"}
        icon={faComment}
        label={"Insert Proof"}
        placeHolder={"Insert Proof"}
        value={getTBWStore().superviseEventProof.get()}
        onChoose={(value: string) =>
          getTBWStore().superviseEventProof.set(value)
        }
        onBlur={() => {}}
        onEnter={() => {}}
        style={{}}
      />

      <ET3Div
        isScrollable={false}
        isExtendable={false}
        fDirection="row"
        justifyContent="space-around"
        alignItems="center"
        withShadow={false}
        width={1000}
        height={100}
        color={colors.all.transparent}
        style={{}}
        onClick={() => {}}
      >
        <Et3Button
          isEnabled={isEnabled}
          onClick={async () => {
            if (getTBWStore().TBWSaveButtonDisabled.get()) {
              getTBWStore().TBWSaveButtonDisabled.set(false);
              await getSuperviseStore().saveAuditedEventAsSupervised({
                eventID: eventIDNumber,
                issueType: status === "minor" ? "minor" : "major"
              });
            }
          }}
          size="LARGE"
          text="SAVE"
          type="APPROVE"
        />
      </ET3Div>
    </React.Fragment>
  );
});
export default SuperviseProofPopUp;
